import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private router: Router,
    public appService: AppService,
    public meta: Meta,
    public title: Title,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.setSEO();
  }
  setSEO() {
    if (this.appService.indexData && this.appService.indexData.attributes.Seo) {
      this.meta.updateTag({ name: 'keywords', content: this.appService.indexData.attributes.Seo.keywords });
      this.meta.updateTag({ name: 'description', content: this.appService.indexData.attributes.Seo.metaDescription });
      this.title.setTitle(this.appService.indexData.attributes.Seo.metaTitle);
    } else {
      this.meta.removeTag('name= "keywords"');
      this.meta.removeTag('name= "description"');
      this.title.setTitle('');
    }
    this.meta.removeTag('name= "robots"');
  }
}
